import { render } from "./RiSortUp.vue?vue&type=template&id=7f9fae66"
import script from "./RiSortUp.vue?vue&type=script&lang=js"
export * from "./RiSortUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiSortUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f9fae66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f9fae66', __exports__)) {
    api.reload('7f9fae66', __exports__)
  }
  
  module.hot.accept("./RiSortUp.vue?vue&type=template&id=7f9fae66", () => {
    api.rerender('7f9fae66', render)
  })

}


export default __exports__